const pwaInstall = {
  'en-us': {
    'pwaInstall.title': 'Would you like to add the IOK Platform to your Home Screen?',
    'pwaInstall.description':
      'Get a better and faster experience when accessing the Platform features!',
    'pwaInstall.install': 'Add',
    'pwaInstall.notNow': 'Not now',
    'pwaInstall.iosTitle': 'Add the IOK Platform to your Home Screen',
    'pwaInstall.iosInstructions':
      'Tap Share in your browser and then tap Add to Home Screen.',
    'pwaInstall.done': 'Got it',
  },
  'pt-br': {
    'pwaInstall.title': 'Deseja adicionar a Plataforma IOK à sua tela inicial?',
    'pwaInstall.description':
      'Tenha uma experiência melhor e mais rápida para acessar as funcionalidades da Plataforma!',
    'pwaInstall.install': 'Adicionar',
    'pwaInstall.notNow': 'Agora não',
    'pwaInstall.iosTitle': 'Adicione a Plataforma IOK à sua tela inicial',
    'pwaInstall.iosInstructions':
      'Toque em Compartilhar no navegador e depois em Adicionar à Tela de Início.',
    'pwaInstall.done': 'Entendi',
  },
  'es-es': {
    'pwaInstall.title': '¿Desea agregar la Plataforma IOK a su pantalla de inicio?',
    'pwaInstall.description':
      '¡Disfrute de una experiencia mejor y más rápida al acceder a las funciones de la Plataforma!',
    'pwaInstall.install': 'Agregar',
    'pwaInstall.notNow': 'Ahora no',
    'pwaInstall.iosTitle': 'Agregue la Plataforma IOK a su pantalla de inicio',
    'pwaInstall.iosInstructions':
      'Toque Compartir en el navegador y luego Agregar a pantalla de inicio.',
    'pwaInstall.done': 'Entendido',
  },
  'fr-ca': {
    'pwaInstall.title': "Voulez-vous ajouter la plateforme IOK à votre écran d’accueil?",
    'pwaInstall.description':
      'Profitez d’une expérience améliorée et plus rapide pour accéder aux fonctionnalités de la plateforme!',
    'pwaInstall.install': 'Ajouter',
    'pwaInstall.notNow': 'Pas maintenant',
    'pwaInstall.iosTitle': "Ajoutez la plateforme IOK à votre écran d’accueil",
    'pwaInstall.iosInstructions':
      'Touchez Partager dans votre navigateur, puis Sur l’écran d’accueil.',
    'pwaInstall.done': 'Compris',
  },
  'de-de': {
    'pwaInstall.title': 'Möchten Sie die IOK-Plattform zum Startbildschirm hinzufügen?',
    'pwaInstall.description':
      'Greifen Sie schneller und komfortabler auf die Funktionen der Plattform zu!',
    'pwaInstall.install': 'Hinzufügen',
    'pwaInstall.notNow': 'Nicht jetzt',
    'pwaInstall.iosTitle': 'IOK-Plattform zum Startbildschirm hinzufügen',
    'pwaInstall.iosInstructions':
      'Tippen Sie im Browser auf Teilen und danach auf Zum Home-Bildschirm.',
    'pwaInstall.done': 'Verstanden',
  },
  'it-it': {
    'pwaInstall.title': 'Vuoi aggiungere la Piattaforma IOK alla schermata Home?',
    'pwaInstall.description':
      'Ottieni un’esperienza migliore e più veloce nell’accesso alle funzionalità della Piattaforma!',
    'pwaInstall.install': 'Aggiungi',
    'pwaInstall.notNow': 'Non ora',
    'pwaInstall.iosTitle': 'Aggiungi la Piattaforma IOK alla schermata Home',
    'pwaInstall.iosInstructions':
      'Tocca Condividi nel browser e poi Aggiungi alla schermata Home.',
    'pwaInstall.done': 'Ho capito',
  },
  'pl-pl': {
    'pwaInstall.title': 'Czy chcesz dodać Platformę IOK do ekranu początkowego?',
    'pwaInstall.description':
      'Korzystaj z funkcji Platformy szybciej i wygodniej!',
    'pwaInstall.install': 'Dodaj',
    'pwaInstall.notNow': 'Nie teraz',
    'pwaInstall.iosTitle': 'Dodaj Platformę IOK do ekranu początkowego',
    'pwaInstall.iosInstructions':
      'Stuknij Udostępnij w przeglądarce, a następnie Do ekranu początkowego.',
    'pwaInstall.done': 'Rozumiem',
  },
  'ru-ru': {
    'pwaInstall.title': 'Добавить платформу IOK на экран «Домой»?',
    'pwaInstall.description':
      'Получите более удобный и быстрый доступ к функциям платформы!',
    'pwaInstall.install': 'Добавить',
    'pwaInstall.notNow': 'Не сейчас',
    'pwaInstall.iosTitle': 'Добавьте платформу IOK на экран «Домой»',
    'pwaInstall.iosInstructions':
      'Нажмите «Поделиться» в браузере, затем «На экран Домой».',
    'pwaInstall.done': 'Понятно',
  },
  'el-gr': {
    'pwaInstall.title': 'Θέλετε να προσθέσετε την Πλατφόρμα IOK στην αρχική οθόνη;',
    'pwaInstall.description':
      'Αποκτήστε καλύτερη και ταχύτερη πρόσβαση στις λειτουργίες της Πλατφόρμας!',
    'pwaInstall.install': 'Προσθήκη',
    'pwaInstall.notNow': 'Όχι τώρα',
    'pwaInstall.iosTitle': 'Προσθέστε την Πλατφόρμα IOK στην αρχική οθόνη',
    'pwaInstall.iosInstructions':
      'Πατήστε Κοινοποίηση στο πρόγραμμα περιήγησης και έπειτα Προσθήκη στην οθόνη Αφετηρίας.',
    'pwaInstall.done': 'Κατάλαβα',
  },
  'zh-zh': {
    'pwaInstall.title': '是否要将 IOK 平台添加到主屏幕？',
    'pwaInstall.description': '更快捷、更方便地访问平台功能！',
    'pwaInstall.install': '添加',
    'pwaInstall.notNow': '暂不',
    'pwaInstall.iosTitle': '将 IOK 平台添加到主屏幕',
    'pwaInstall.iosInstructions': '在浏览器中轻点“共享”，然后轻点“添加到主屏幕”。',
    'pwaInstall.done': '知道了',
  },
  'hu-hu': {
    'pwaInstall.title': 'Hozzáadja az IOK Platformot a Főképernyőhöz?',
    'pwaInstall.description':
      'Érje el gyorsabban és kényelmesebben a Platform funkcióit!',
    'pwaInstall.install': 'Hozzáadás',
    'pwaInstall.notNow': 'Most nem',
    'pwaInstall.iosTitle': 'Adja hozzá az IOK Platformot a Főképernyőhöz',
    'pwaInstall.iosInstructions':
      'Koppintson a böngésző Megosztás gombjára, majd a Főképernyőhöz adás lehetőségre.',
    'pwaInstall.done': 'Értem',
  },
  'cs-cs': {
    'pwaInstall.title': 'Chcete přidat platformu IOK na plochu?',
    'pwaInstall.description':
      'Získejte rychlejší a pohodlnější přístup k funkcím platformy!',
    'pwaInstall.install': 'Přidat',
    'pwaInstall.notNow': 'Teď ne',
    'pwaInstall.iosTitle': 'Přidejte platformu IOK na plochu',
    'pwaInstall.iosInstructions':
      'V prohlížeči klepněte na Sdílet a potom na Přidat na plochu.',
    'pwaInstall.done': 'Rozumím',
  },
  'da-dk': {
    'pwaInstall.title': 'Vil du føje IOK-platformen til hjemmeskærmen?',
    'pwaInstall.description':
      'Få hurtigere og nemmere adgang til platformens funktioner!',
    'pwaInstall.install': 'Tilføj',
    'pwaInstall.notNow': 'Ikke nu',
    'pwaInstall.iosTitle': 'Føj IOK-platformen til hjemmeskærmen',
    'pwaInstall.iosInstructions':
      'Tryk på Del i browseren og derefter på Føj til hjemmeskærm.',
    'pwaInstall.done': 'Forstået',
  },
  'fi-fi': {
    'pwaInstall.title': 'Haluatko lisätä IOK-alustan Koti-valikkoon?',
    'pwaInstall.description':
      'Käytä alustan toimintoja nopeammin ja sujuvammin!',
    'pwaInstall.install': 'Lisää',
    'pwaInstall.notNow': 'Ei nyt',
    'pwaInstall.iosTitle': 'Lisää IOK-alusta Koti-valikkoon',
    'pwaInstall.iosInstructions':
      'Napauta selaimessa Jaa ja sitten Lisää Koti-valikkoon.',
    'pwaInstall.done': 'Selvä',
  },
  'no-no': {
    'pwaInstall.title': 'Vil du legge IOK-plattformen til på Hjem-skjermen?',
    'pwaInstall.description':
      'Få raskere og enklere tilgang til plattformens funksjoner!',
    'pwaInstall.install': 'Legg til',
    'pwaInstall.notNow': 'Ikke nå',
    'pwaInstall.iosTitle': 'Legg IOK-plattformen til på Hjem-skjermen',
    'pwaInstall.iosInstructions':
      'Trykk på Del i nettleseren og deretter på Legg til på Hjem-skjermen.',
    'pwaInstall.done': 'Forstått',
  },
  'sv-se': {
    'pwaInstall.title': 'Vill du lägga till IOK-plattformen på hemskärmen?',
    'pwaInstall.description':
      'Få snabbare och smidigare åtkomst till plattformens funktioner!',
    'pwaInstall.install': 'Lägg till',
    'pwaInstall.notNow': 'Inte nu',
    'pwaInstall.iosTitle': 'Lägg till IOK-plattformen på hemskärmen',
    'pwaInstall.iosInstructions':
      'Tryck på Dela i webbläsaren och sedan på Lägg till på hemskärmen.',
    'pwaInstall.done': 'Jag förstår',
  },
};

export default pwaInstall;

